// @ts-ignore
import { isMobile } from 'buefy';
import { BaseUIService } from '/@/modules/core/ui/services/BaseUIService';
import { DeviceBreakpoint } from '@/modules/core/ui/enums/DeviceBreakpoint';

export class DeviceService extends BaseUIService {
  isMobile(): boolean {
    return !!isMobile.any();
  }

  isMac(): boolean {
    return navigator?.userAgent.indexOf('Mac OS X') !== -1;
  }

  isDesktop(): boolean {
    return this.getViewportWidth() >= DeviceBreakpoint.DESKTOP;
  }

  async isAdBlockerActive(): Promise<boolean> {
    try {
      await fetch(
        new Request(`https://ads.google.com?=${new Date().getTime()}`, {
          method: 'HEAD',
          mode: 'no-cors'
        })
      );
      return false;
    } catch (e) {
      return true;
    }
  }

  hasLocalStorageBlocked(): boolean {
    try {
      window.localStorage;

      return false;
    } catch (e) {
      return true;
    }
  }

  async copyToClipboard(text: string): Promise<void> {
    await navigator?.clipboard.writeText(text);
  }

  getViewportHeight(): number {
    return Math.max(document?.documentElement.clientHeight, window?.innerHeight || 0);
  }

  getViewportWidth(): number {
    return Math.max(document?.documentElement.clientWidth, window?.innerWidth || 0);
  }
}

export default new DeviceService();
